import { render, staticRenderFns } from "./recruitInfo.vue?vue&type=template&id=8101c09a&scoped=true"
import script from "./recruitInfo.vue?vue&type=script&lang=js"
export * from "./recruitInfo.vue?vue&type=script&lang=js"
import style0 from "./recruitInfo.vue?vue&type=style&index=0&id=8101c09a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8101c09a",
  null
  
)

export default component.exports